import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type SierraAlarmAcknowledgeEndpointSpecification = ApiEndpointSpecification;
export const SierraAlarmAcknowledgeEndpointSpecification: SierraAlarmAcknowledgeEndpointSpecification = {
    url: '/api/alarm/acknowledgement/sierra',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'SierraAlarmAcknowledgeRequestParams',
    requestBodySchemaName: 'SierraAlarmAcknowledgeRequestBody',
    okResponseSchemaName: 'SierraAlarmAcknowledgeOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSierraAlarmAcknowledge = Helpers.makeApiRequestFn<
    Types.SierraAlarmAcknowledgeRequestParams,
    Types.SierraAlarmAcknowledgeRequestBody,
    Types.SierraAlarmAcknowledgeOkResponse
>(SierraAlarmAcknowledgeEndpointSpecification);
